var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppIllustrator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#330000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6316 14.4319H25.55L34.4309 39.2236H27.1785L25.9573 35.4495H16.6697L15.4485 39.2236H8.49194L17.6316 14.4319ZM24.0334 29.5659L21.3323 21.2405L18.6311 29.5659H24.0334Z",
    fill: "#FF9A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7756 16.0601C35.7756 14.2839 37.1448 13.1367 39.217 13.1367C41.2522 13.1367 42.5471 14.3208 42.5471 16.0601C42.5471 17.8362 41.2522 19.0571 39.217 19.0571C37.0706 19.0571 35.7756 17.873 35.7756 16.0601ZM35.9607 19.9082H42.4363V39.2236H35.9607V19.9082Z",
    fill: "#FF9A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppIllustrator);
export default __webpack_public_path__ + "static/media/B_app_Illustrator.e35b22185fdd4dc9a378e7815aa50bf8.svg";
export { ForwardRef as ReactComponent };